import useTenTrendingProducts from "hook/useTenTrendingProducts";
import { useEffect, useRef, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ShimmerTrendingProducts from "components/shimmer/ShimmerTrendingProducts";
import ProductCard from "components/ProductCard";

const TrendingProducts = () => {
  const { tenTrendingProducts, loading1 } = useTenTrendingProducts();
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    // Run once after render to set initial button states
    const timer = setTimeout(checkScroll, 100);

    window.addEventListener("resize", checkScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkScroll);
    };
  }, [tenTrendingProducts]); // re-run when products are loaded

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
  };

  if (loading1) {
    return <ShimmerTrendingProducts />;
  }

  if (!loading1 && tenTrendingProducts.length === 0) {
    return <div></div>;
  }
  return (
    <section className="sm:mt-10 mt-5 px-4 sm:px-6">
      {tenTrendingProducts.length > 0 ? (
        <div>
          <div className="mb-4 flex justify-between items-center">
            <div>
              <h3 className="text-xl font-bold text-slate-900 sm:text-2xl">
                Trending Products
              </h3>
              <p className="text-sm text-slate-600 sm:text-base">
                Top picks with ongoing deals.
              </p>
            </div>
            <div>
              <button
                type="button"
                onClick={() => navigate("/trendingProducts")}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 sm:text-sm"
              >
                View All
                <FaArrowRight />
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 lg:grid-cols-5">
            {tenTrendingProducts
              .filter((item) => item.hideStatus === "available")
              .map((item) => (
                <ProductCard
                  key={item.id}
                  item={item}
                  bgClass="bg-white"
                  currencyClass="text-slate-900"
                />
              ))}
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default TrendingProducts;
